import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

// Lazily-loaded so the heavy MeetingsPanel subtree stays off the feed critical bundle.
export const LoadableMeetingsPanel: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MeetingsPanel" */ './MeetingsPanelWithProvider.tsx'
			)
		).MeetingsPanelWithProvider,
});
